import * as React from "react";
import { FloatingList } from "@floating-ui/react";
import { clsx } from "clsx";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
import { ListboxProvider } from "./listbox-context.mjs";
import { useListbox } from "./use-listbox.mjs";
const Listbox = (props) => {
  return /* @__PURE__ */ React.createElement(PropsChecker, { componentProps: props, componentName: "Listbox", defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange" }, /* @__PURE__ */ React.createElement(ListboxInner, { ...props }));
};
const ListboxInner = ({ children, defaultValue = null, value, onChange, className, ...rest }) => {
  const context = useListbox({ defaultValue, value, onChange });
  const { getFloatingProps, refs, elementsRef, labelsRef } = context;
  return /* @__PURE__ */ React.createElement("ul", { ...rest, className: clsx("listbox", className), ref: refs.setFloating, ...getFloatingProps() }, /* @__PURE__ */ React.createElement(ListboxProvider, { value: context }, /* @__PURE__ */ React.createElement(FloatingList, { elementsRef, labelsRef }, children)));
};
export {
  Listbox
};
